import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { INoneNegativeCarryoverResponse, INoneNegativeCarryoverResponseData } from '../types';
import {
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_API_URL,
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_QUERY,
} from '../constants';

export default function useShowNoneNegativeCarryoverQuery(id: Ref<number>): IContextQueryResult<
  INoneNegativeCarryoverResponse,
  Error,
  INoneNegativeCarryoverResponseData
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<INoneNegativeCarryoverResponse, Error, INoneNegativeCarryoverResponseData>({
    queryKey: [AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_QUERY, id],
    queryFn: ({ signal }) => fetchGet<INoneNegativeCarryoverResponse>(
      AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
    select: (data) => data.nnco,
  });
}
